import { Component, EventEmitter, inject, Input, OnInit, Output } from '@angular/core';
import { filter, take } from 'rxjs/operators';
import { FormsModule } from '@angular/forms';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { MatLegacyCheckboxModule as MatCheckboxModule } from '@angular/material/legacy-checkbox';
import { MatLegacyButtonModule as MatButtonModule } from '@angular/material/legacy-button';
import { MatLegacyTooltipModule as MatTooltipModule } from '@angular/material/legacy-tooltip';
import { MatIconModule } from '@angular/material/icon';
import { MatLegacyDialog as MatDialog } from '@angular/material/legacy-dialog';

import { PlaylistItemDTO } from '../../../../core/models/view-models/playlist-item-models/playlist-item-dto.model';
import { TimerConfig } from '../../../../core/models/entities/timer-config.type';
import { AppConstants } from '../../../../app.constants';
import { ModalConfigureTimerComponent } from '../../../../shared-module/components/_modals/modal-configure-timer/modal-configure-timer.component';
import { DurationPickerComponent } from '../../../../misc/duration-picker/duration-picker.component';
import { TimerType } from '../../../../core/enums/timer-type.enum';

@Component({
  selector: 'tab-timer',
  standalone: true,
  imports: [
    FormsModule,
    MatToolbarModule,
    MatButtonToggleModule,
    MatCheckboxModule,
    MatButtonModule,
    MatTooltipModule,
    MatIconModule,
    DurationPickerComponent,
  ],
  templateUrl: './tab-timer.component.html',
  styleUrls: [
    './tab-timer.component.scss',
    '../../../modal-playlist-item/playlist-item-dialog.component.scss'
  ]
})
export class TabTimerComponent implements OnInit {
  @Input() playlistItem: PlaylistItemDTO;
  @Output() submit = new EventEmitter<void>();
  @Output() cancel = new EventEmitter<void>();

  timerTypes = TimerType;

  private dialog = inject(MatDialog);

  ngOnInit(): void {
    this.playlistItem.TimerConfig = this.playlistItem.TimerConfig || new TimerConfig();
  }

  onConfigureTimer() {
    this.dialog.open(
      ModalConfigureTimerComponent,
      {
        data: structuredClone(this.playlistItem.TimerConfig),
        ...AppConstants.TIMER_SETTINGS_DIALOG_WINDOW_CONFIG
      }
    ).afterClosed().pipe(
      filter((data: TimerConfig) => !!data),
      take(1)
    ).subscribe(data => {
      this.playlistItem.TimerConfig = data;
    });
  }

  onSubmit() {
    this.playlistItem.PlaylistItemTitle = this.setTitle(this.playlistItem);
    this.playlistItem.RssConfigs = null;
    this.submit.emit();
  }

  onTypeChange() {
    this.playlistItem.TimerConfig.TimerInterval = AppConstants.DEFAULT_PLAYLIST_ITEM_DURATION;

    if (this.playlistItem.TimerConfig.TimerType === TimerType.Timer) {
      this.playlistItem.TimerConfig.ShowSeconds = false;
    }
  }

  private setTitle(item: PlaylistItemDTO): string {
    const titleMap: Record<TimerType, string> = {
      [TimerType.Clock]: AppConstants.CLOCK_ITEM_TITLE,
      [TimerType.Timer]: AppConstants.TIMER_ITEM_TITLE,
    };
    return titleMap[item.TimerConfig.TimerType];
  }
}
